import { ReactComponent as Support } from "assets/icons/support-black.svg";
import { useTranslation } from "react-i18next";

const SupportUs = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex justify-center space-x-2 caption-12px-medium text-primary-1 mt-3 ${className}`}
    >
      <Support className="ml-2 w-5 h-5 [&>g>path]:fill-primary-0" />
      <span>{t("call-support")}:</span>
      <a href="tel:09001079672">۰۹۰۰۱۰۷۹۶۷۲</a>
    </div>
  );
};

export default SupportUs;
